import React, { Component } from 'react'
import Paragraph from 'grommet/components/Paragraph'
import Button from 'grommet/components/Button'
import NavigateIcon from 'grommet/components/icons/base/Navigate'
import facebookLogo from './resources/facebook-logo.png'
import twitterLogo from './resources/twitter-logo.png'
import instagramLogo from './resources/instagram-logo.png'
import './Footer.css'

class Footer extends Component {
  showSiteMapHandler = () => {
    console.log('** click')
  }
  render() {
    return (
      <div className="Footer">
        <div className="Footer-container">
          <div className="Footer-block">
            <div className="Footer-socialIconsContainer">
              <a rel="noopener noreferrer" target="_blank" href="https://facebook.com/coppercoasttechnologies"><img alt="Facebook" className="Footer-socialIcon" src={facebookLogo} /></a>
              <a rel="noopener noreferrer" target="_blank" href="https://twitter.com/coppercoasttech"><img alt="Twitter" className="Footer-socialIcon" src={twitterLogo} /></a>
              <a rel="noopener noreferrer" target="_blank" href="https://instagram.com/coppercoasttechnologies"><img className="Footer-socialIcon" alt="Instagram" src={instagramLogo} /></a>
              <Button plain path="/sitemap" className="Footer-siteMapIcon">
                <NavigateIcon/>
              </Button>
            </div>
          </div>
          <div className="Footer-block">
            <div className="Footer-copyrightContainer">
              <Paragraph className="Footer-copyrightNotice">© Copyright 2022. Copper Coast Technologies Ltd. All Rights Reserved.</Paragraph>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/index.js